import collectionEpics from './epics';
import reducer from './reducers';
import * as collectionSelectors from './selectors';
import * as collectionTypes from './types';

export { collectionTypes, collectionSelectors, collectionEpics };

export default reducer;
